import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function CoreTimeIntroDialog({ isOpen, close }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="xs">
      <DialogTitle variant="h5" sx={{ px: { xs: 3, sm: 4 }, py: { xs: 3, sm: 4 } }}>
        코어 타임 기능이 추가됐어요 🎉
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 3, sm: 4 } }}>
        <Typography variant="h6" gutterBottom>
          🤔 코어 타임이 무엇인가요?
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: { xs: 3, sm: 4 } }}>
          출퇴근 시스템을 이용하기로 크루가 약속한 시간이에요.
        </Typography>

        <Typography variant="h6" gutterBottom>
          ⏰ 어떻게 활용하면 되나요?
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          코어 타임을 참고해 크루의 업무를 체크하거나 소통해 보세요. 코어 타임은 언제든지 크루와 상의해서 옮길 수 있어요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" fullWidth={!smUp} size="large" sx={{ px: 3 }} onClick={close} >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}